import { StyledImageLogo } from '../TheWestHeader.styled'
import { createHeaderLogo, LogoProps } from './createHeaderLogo'

const logoFile = require('./images/masthead-south-western-times.png')

const props: LogoProps = {
    alt: 'South Western Times',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
    verticalSpacing: 14,
}

export default createHeaderLogo(StyledImageLogo, props)
